module.exports = __webpack_public_path__ + "static/media/Savings_Diagram_Mobile_EN.9891a8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savings_Diagram_Mobile_EN.png
// module id = 559
// module chunks = 0